import {
  getCorePage,
  getFooter,
  getGlobalLegalPages,
} from "../../core/api/core";

import Head from "next/head";
import { LEGAL_SLUG } from "../../core/urls";
import LegalPage from "../../components/LegalPage";
import Metatags from "../../components/Metatags";
import React from "react";
import { getMenu } from "../../core/api/menu";

function CorePage({ data, menuData, globalData }) {
  const { title } = data.wagtail.corePage;

  return (
    <>
      <Head>
        <title>Reskinned | {title}</title>
      </Head>
      <Metatags
        metaTitle={data.wagtail.corePage.metaTitle}
        metaDescription={data.wagtail.corePage.metaDescription}
      />
      <LegalPage
        pageData={data.wagtail.corePage}
        navItems={menuData}
        globalData={globalData}
      />
    </>
  );
}

export default CorePage;

export async function getStaticProps({ params }) {
  const { data } = await getCorePage(null, params.slug);
  const menuData = await getMenu();
  const globalData = await getFooter();

  if (!data.wagtail.corePage) {
    return { notFound: true };
  }

  return {
    props: {
      data,
      menuData,
      globalData,
    },
    revalidate: 300,
  };
}

export async function getStaticPaths() {
  const { data, errors } = await getGlobalLegalPages();

  const paths = errors.length
    ? []
    : data.wagtail.globalLegalPages.map((legalPage) => {
        return `/${LEGAL_SLUG}/${legalPage.slug}`;
      });

  return {
    paths,
    fallback: "blocking",
  };
}
